import { useCount } from "@/utils/count";

const load = async () => {
    await useCount().countSupport();
};
export default [
    {
        path: "/omp",
        name: "omp__root__",
        redirect: {
            name: "omp-index",
        },
        component: () => import("@/layouts/default.vue"),
        meta: {
            parent: "omp",
            title: "",
        },
        beforeEnter: async (to, from, next) => {
            await load();
            next();
        },
        children: [
            {
                path: "index",
                name: "omp-index",
                component: () => import("@/views/omp/index.vue"),
                meta: {
                    title: "控制面板",
                    icon: "index",
                    affix: true,
                },
            },
        ],
    },
    {
        path: "/omp/conf",
        name: "omp-conf",
        meta: {
            title: "基础设置",
            icon: "atom",
            parent: "omp",
            permission: "manage_system_conf",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/omp/conf/global",
        children: [
            {
                path: "global",
                name: "omp-conf-global",
                component: () => import("@/views/omp/conf/index"),
                meta: {
                    title: "全局配置",
                    icon: "global",
                    affix: false,
                },
            },
            {
                path: "notice",
                name: "omp-conf-notice",
                component: () => import("@/views/omp/conf/notice"),
                meta: {
                    title: "公告配置",
                    icon: "notice",
                    affix: false,
                    permission: "manage_common_notice",
                },
            },
            {
                path: "menu",
                name: "omp-conf-menu",
                component: () => import("@/views/omp/conf/menu"),
                meta: {
                    title: "菜单配置",
                    icon: "menu",
                    affix: false,
                    permission: "manage_common_menu",
                },
            },
            {
                path: "group",
                name: "omp-conf-group",
                component: () => import("@/views/omp/conf/group"),
                meta: {
                    title: "分组配置",
                    icon: "group",
                    affix: false,
                    permission: "manage_common_group",
                },
            },
        ],
    },
    {
        path: "/omp/mall",
        name: "omp-mall",
        meta: {
            title: "商城管理",
            icon: "mall",
            parent: "omp",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/omp/mall/goods",
        children: [
            {
                path: "goods",
                name: "omp-mall-goods",
                component: () => import("@/views/omp/mall/goods"),
                meta: {
                    title: "商品管理",
                    icon: "goods",
                    affix: false,
                    permission: "manage_mall_goods",
                },
            },
            {
                path: "banner",
                name: "omp-mall-banner",
                component: () => import("@/views/omp/mall/banner"),
                meta: {
                    title: "推广管理",
                    icon: "banner",
                    affix: false,
                },
            },
            {
                path: "goods-detail/:id(\\d+)?",
                name: "omp-mall-goods-detail",
                component: () => import("@/views/omp/mall/goods-detail"),
                hidden: true,
                meta: {
                    title: "商品详情",
                    icon: "goods",
                    affix: false,
                    permission: "manage_mall_goods",
                    activeMenu: "/omp/mall/goods",
                },
            },
            {
                path: "goods-data/:id(\\d+)?",
                name: "omp-mall-goods-data",
                component: () => import("@/views/omp/mall/goods-data"),
                hidden: true,
                meta: {
                    title: "商品详情",
                    icon: "goods",
                    affix: false,
                    permission: "manage_mall_goods",
                    activeMenu: "/omp/mall/goods",
                },
            },
            {
                path: "category",
                name: "omp-mall-category",
                component: () => import("@/views/omp/mall/category"),
                meta: {
                    title: "商品分类",
                    icon: "goods_type",
                    affix: false,
                    permission: "manage_mall_goods_category",
                },
            },
            {
                path: "tag",
                name: "omp-mall-tag",
                component: () => import("@/views/omp/mall/tag"),
                meta: {
                    title: "标签管理",
                    icon: "tag",
                    affix: false,
                    permission: "manage_mall_goods_tag",
                },
            },
            {
                path: "decoration",
                name: "omp-mall-decoration",
                component: () => import("@/views/omp/mall/decoration"),
                meta: {
                    title: "装饰管理",
                    icon: "decoration",
                    affix: false,
                    permission: "manage_mall_goods_decoration",
                },
            },
            {
                path: "fee/shipping",
                name: "omp-mall-fee-shipping",
                component: () => import("@/views/omp/mall/shipping-fee"),
                meta: {
                    title: "邮费管理",
                    icon: "shipping",
                    affix: false,
                    permission: "manage_mall_shipping_fee",
                },
            },
        ],
    },
    {
        path: "/omp/server",
        name: "omp-server",
        meta: {
            title: "服务管理",
            icon: "server",
            parent: "omp",
            group: 256,
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/omp/server/product",
        children: [
            {
                path: "product",
                name: "dev-conf-product",
                component: () => import("@/views/dev/conf/product.vue"),
                meta: {
                    title: "产品配置",
                    icon: "product",
                    affix: false,
                    group: 512,
                },
            },
            {
                path: "product-detail/:id(\\d+)?",
                name: "dev-conf-product-detail",
                hidden: true,
                component: () => import("@/views/dev/conf/product-detail.vue"),
                meta: {
                    title: "产品配置详情",
                    affix: false,
                    activeMenu: "/omp/server/product",
                    group: 512,
                },
            },
            {
                path: "purchase-record",
                name: "omp-server-purchase-record",
                component: () => import("@/views/dev/conf/purchase-record.vue"),
                meta: {
                    title: "售卖统计",
                    icon: "purchase-records",
                    affix: false,
                },
            },
            {
                path: "exception",
                name: "omp-server-exception",
                component: () => import("@/views/omp/server/exception.vue"),
                meta: {
                    title: "异常处理",
                    icon: "exception-handle",
                    affix: false,
                },
            }
        ]
    },
    {
        path: "/omp/promotion",
        name: "omp-promotion",
        meta: {
            title: "推广管理",
            icon: "promotion",
            parent: "omp",
            group: 256,
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/omp/promotion/voucher-type",
        children: [
            {
                path: "voucher-type",
                name: "omp-promotion-voucher-type",
                component: () => import("@/views/omp/server/voucher-type.vue"),
                meta: {
                    title: "礼品卡配置",
                    icon: "gift-manage",
                    affix: false,
                },
            },
            {
                path: "voucher-batch",
                name: "omp-promotion-voucher-batch",
                component: () => import("@/views/omp/server/voucher-batch-list.vue"),
                meta: {
                    title: "礼品卡管理",
                    icon: "gift",
                    affix: false,
                },
            },
            {
                path: "voucher/:id(\\d+)",
                name: "omp-promotion-voucher-detail",
                component: () => import("@/views/omp/server/voucher-batch-detail.vue"),
                hidden: true,
                meta: {
                    title: "批次详情",
                    icon: "promotion",
                    affix: false,
                    activeMenu: "/omp/promotion/voucher-batch",
                },
            },
            {
                path: "lucky-setting",
                name: "omp-promotion-lucky-setting",
                component: () => import("@/views/omp/server/voucher-type.vue"),
                meta: {
                    title: "幸运码配置",
                    icon: "lucky-manage",
                    affix: false,
                },
            },
            {
                path: "lucky-manage",
                name: "omp-promotion-lucky-manage",
                component: () => import("@/views/omp/server/voucher-batch-list.vue"),
                meta: {
                    title: "幸运码管理",
                    icon: "lucky",
                    affix: false,
                },
            },
        ]
    },
    {
        path: "/omp/msg",
        name: "omp-msg",
        meta: {
            title: "消息中心",
            icon: "message",
            parent: "omp",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/omp/msg/email",
        children: [
            {
                path: "message",
                name: "omp-msg-message",
                component: () => import("@/views/omp/msg/message.vue"),
                meta: {
                    title: "私信管理",
                    icon: "private",
                    permission: "manage_message",
                },
            },
            {
                path: "email",
                name: "omp-msg-email",
                component: () => import("@/views/omp/msg/email.vue"),
                meta: {
                    title: "邮件管理",
                    icon: "email",
                    permission: "manage_email_log",
                },
            },
            {
                path: "email-sending",
                name: "omp-msg-email-sending",
                hidden: true,
                component: () => import("@/views/omp/msg/email-sending.vue"),
                meta: {
                    title: "发送邮件",
                    affix: false,
                    permission: "send_email",
                    activeMenu: "/omp/msg/email",
                },
            },
            {
                path: "phone-msg",
                name: "omp-msg-phone-msg",
                component: () => import("@/views/omp/msg/phone-msg.vue"),
                meta: {
                    title: "短信管理",
                    icon: "phone-msg",
                    permission: "manage_sms_log",
                },
            },
            {
                path: "phone-sending",
                name: "omp-msg-phone-sending",
                hidden: true,
                component: () => import("@/views/omp/msg/phone-sending.vue"),
                meta: {
                    title: "发送短信",
                    affix: false,
                    permission: "send_sms",
                    activeMenu: "/omp/msg/phone-msg",
                },
            },
            {
                path: "wxmsg",
                name: "omp-msg-wxmsg",
                component: () => import("@/views/omp/msg/wxmsg.vue"),
                meta: {
                    title: "微信管理",
                    icon: "wxmsg",
                    permission: "manage_wxmsg_log",
                },
            },
        ],
    },
    {
        path: "/omp/support",
        name: "omp-support",
        meta: {
            title: "支持中心",
            icon: "support",
            parent: "omp",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/omp/support/contact",
        beforeEnter: async (to, from, next) => {
            await load();
            next();
        },
        children: [
            {
                path: "contact",
                name: "omp-support-contact",
                component: () => import("@/views/omp/support/contact.vue"),
                meta: {
                    title: "留言管理",
                    icon: "comment",
                    permission: "manage_common_contact",
                },
            },
            {
                path: "feedback",
                name: "omp-support-feedback",
                component: () => import("@/views/omp/support/feedback.vue"),
                meta: {
                    title: "反馈管理",
                    icon: "feedback",
                    permission: "manage_common_feedback",
                },
            },
            {
                path: "feedback-detail/:id(\\d+)",
                name: "omp-support-feedback-detail",
                component: () => import("@/views/common/account/feedback-detail.vue"),
                hidden: true,
                meta: {
                    title: "反馈管理",
                    icon: "feedback",
                    permission: "manage_common_feedback",
                    activeMenu: "/omp/support/feedback",
                },
            },
        ],
    },
    {
        path: "/omp/user",
        name: "omp-user",
        meta: {
            title: "用户管理",
            icon: "users",
            parent: "omp",
            permission: "manage_user",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/omp/user/account",
        children: [
            {
                path: "account",
                name: "omp-user-account",
                component: () => import("@/views/omp/user/account"),
                meta: {
                    title: "账号管理",
                    icon: "user",
                    affix: false,
                },
            },
            {
                path: "abnormality",
                name: "omp-user-abnormality",
                component: () => import("@/views/omp/user/abnormality"),
                meta: {
                    title: "账号异常",
                    icon: "abnormality",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/omp/user-log",
        name: "omp-user-log",
        component: () => import("@/layouts/default.vue"),
        redirect: "/omp/user-log/action-log",
        meta: {
            title: "用户日志",
            icon: "log",
            parent: "omp",
            permission: "manage_user_action_log",
        },
        children: [
            {
                path: "action-log",
                name: "omp-user-action-log",
                component: () => import("@/views/dev/log/user/action-log.vue"),
                meta: {
                    title: "操作日志",
                    icon: "user-log",
                },
            },
        ],
    },
];
